import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
} from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import IconifyIcon from "../../base/IconifyIcon";

const activities = [
  {
    id: 1,
    user: "John Doe",
    action: "added a new garden",
    icon: "mdi:leaf",
    timestamp: new Date(),
  },
  {
    id: 2,
    user: "Alice",
    action: "updated fertilizer inventory",
    icon: "mdi:shovel",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 3),
  },
  {
    id: 3,
    user: "Michael",
    action: "recorded harvest from Field A",
    icon: "mdi:corn",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 12),
  },
  {
    id: 4,
    user: "Linda",
    action: "added weather data",
    icon: "mdi:weather-partly-cloudy",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24),
  },
];

const ActivityFeed = () => {
  return (
    <Card elevation={3}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Recent Activity
        </Typography>
        <List disablePadding>
          {activities.map((activity, index) => (
            <React.Fragment key={activity.id}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar
                    sx={{ bgcolor: "primary.main", width: 36, height: 36 }}
                  >
                    <IconifyIcon
                      icon={activity.icon}
                      width={20}
                      height={20}
                      color="#fff"
                    />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="body1">
                      <strong>{activity.user}</strong> {activity.action}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      {formatDistanceToNow(new Date(activity.timestamp), {
                        addSuffix: true,
                      })}
                    </Typography>
                  }
                />
              </ListItem>
              {index < activities.length - 1 && <Divider variant="inset" />}
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default ActivityFeed;
